import { atom, selector } from 'recoil';

import { ALERT_LEVEL } from '@/lib/constants';
import { DisruptionAlertModel } from '@/lib/models/disruption-alert/types';

export const disruptionAlertsState = atom<DisruptionAlertModel[]>({
  key: 'disruptionAlertsState',
  default: [],
});

export const mapDisruptionAlertsState = selector<DisruptionAlertModel[]>({
  key: 'mapDisruptionAlertsState',
  get: ({ get }) => {
    const allAlerts = get(disruptionAlertsState);
    return allAlerts.filter((alert) => alert.level === ALERT_LEVEL.EXTREME && alert.location.type === 'point');
  },
});
